import gameNames from 'a/hub/data/GameIds';

export const GAME_ID = gameNames.RHYME_TIME;

export const WINDOWS = {
  PROGRESS: 'progress',
  STANDARD: 'standard',
  ONBOARDING: 'onboarding',
  ONBOARDING_REPEAT: 'onboarding_repeat',
  PRACTICE: 'practice',
  LOADING: 'loading',
};

// Select container draggable.
export const CLASS_WORD_PART = '.wordPart';

// Alex states
export const ALEX_STATES = {
  INACTIVE: 0,
  ACTIVE: 1,
  SPEAKING: 2,
};

export const REDUX_ACTIONS = {
  SET_ACTIVITY_WINDOW: 'SET_ACTIVITY_WINDOW',
  SET_ALEX_INACTIVE: 'SET_ALEX_INACTIVE',
  SET_ALEX_ACTIVE: 'SET_ALEX_ACTIVE',
  SET_ALEX_SPEAKING: 'SET_ALEX_SPEAKING',
  SET_INTERACTION_LOCKED: 'SET_INTERACTION_LOCKED',
  INIT_DRAG_AND_DROP: 'INIT_DRAG_AND_DROP',
  SET_TILE_DRAGGED: 'SET_TILE_DRAGGED',
  SET_HIGHLIGHTED_PICTURE: 'SET_HIGHLIGHTED_PICTURE',
  INIT_ONBOARDING: 'INIT_ONBOARDING',
  SET_FEEDBACK_VISIBLE: 'SET_FEEDBACK_VISIBLE',
  INIT_PRACTICE: 'INIT_PRACTICE',
  INIT_ROUND: 'INIT_ROUND',
  NEXT_QUESTION: 'NEXT_QUESTION',
  INCREMENT_ANSWER_ATTEMPTS: 'INCREMENT_ANSWER_ATTEMPTS',
  SIMPLIFY_QUESTION: 'SIMPLIFY_QUESTION',
  INCREMENT_QUESTIONS_CORRECT: 'INCREMENT_QUESTIONS_CORRECT',
  INCREMENT_QUESTIONS_ANSWERED: 'INCREMENT_QUESTIONS_ANSWERED',
  SET_LAST_LEVEL_MASTERED: 'SET_LAST_LEVEL_MASTERED',
  SET_HAS_SEEN_ONBOARDING: 'SET_HAS_SEEN_ONBOARDING',
  SET_LEVEL_MASTERED: 'SET_LEVEL_MASTERED',
  INCREMENT_FIRST_ATTEMPT_ANSWERS: 'INCREMENT_FIRST_ATTEMPT_ANSWERS',
  MOVE_QUESTION_TO_THE_END: 'MOVE_QUESTION_TO_THE_END',
  SELECT_TILE: 'SELECT_TILE',
  RESET_SELECTED_TILE: 'RESET_SELECTED_TILE',
  SELECT_ONBOARDING_TILE: 'SELECT_ONBOARDING_TILE',
  SIMPLIFY_ONBOARDING_QUESTION: 'SIMPLIFY_ONBOARDING_QUESTION',
  SET_ACCESSIBILITY_GROUP: 'SET_ACCESSIBILITY_GROUP',
  INIT_ACCESSIBILITY: 'INIT_ACCESSIBILITY',
  SET_WINDOW_LAYOUT: 'SET_WINDOW_LAYOUT',
  SET_PLACEHOLDER_HIGHLIGHTED: 'SET_PLACEHOLDER_HIGHLIGHTED',
  SET_PRACTICE_INTRO_COMPLETED: 'SET_PRACTICE_INTRO_COMPLETED',
  RESET_PRACTICE_SELECTED_TILE: 'RESET_PRACTICE_SELECTED_TILE',
  NEXT_PRACTICE_QUESTION: 'NEXT_PRACTICE_QUESTION',
  SELECT_PRACTICE_TILE: 'SELECT_PRACTICE_TILE',
  INCREMENT_PRACTICE_QUESTIONS_ANSWERED: 'INCREMENT_PRACTICE_QUESTIONS_ANSWERED',
  ADD_PRACTICE_QUESTION: 'ADD_PRACTICE_QUESTION',
  SET_WORD_PARTS_SHIFTED: 'SET_WORD_PARTS_SHIFTED',
  QUICK_ROUND: 'QUICK_ROUND',
};
